import { FaInstagram, FaTelegramPlane, FaTwitter, FaYoutube } from "react-icons/fa";
import './Footer.scss';
const Footer = () => {
  return (
    <div className="_footer">
      <div className="container">
        <div className="wrapper">
          <div className="row mb-0 mb-md-3 justify-content-center text-center">
            <div className="col-md-1 col-2">
              <div className="social-item">
                <a href="https://twitter.com/idmtoken/" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
              </div>
            </div>
            <div className="col-md-1 col-2">
              <div className="social-item">
                <a href="https://www.instagram.com/idm_token/" target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>
            <div className="col-md-1 col-2">
              <div className="social-item">
                <a href="https://www.youtube.com/channel/UCmQ14hRoDh3bB3ntJDgGhEw" target="_blank" rel="noopener noreferrer">
                  <FaYoutube />
                </a>
              </div>
            </div>
            <div className="col-md-1 col-2">
              <div className="social-item">
                <a href="https://t.me/IDMTokenGlobal" target="_blank" rel="noopener noreferrer">
                  <FaTelegramPlane />
                </a>
              </div>
            </div>
          </div>
          <div className="text-center copyright">
            Copyright © 2021 IDM Coop, All rights reserved.
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
